import { DateTime } from 'luxon';
import { QUESTIONNAIRE_TENX_DATA } from './tenx.data';
import {
  QuestionnaireTenxFormField,
  QuestionnaireTenxOption
} from './tenx.interface';

/**
 * @description Selects the Questionnaire Tenx state from the store.
 * @param {string} date Date string to compare.
 * @returns {boolean} Whether the date is greater than one month ago.
 */
export const qUtilsTenxIsDateGreaterThanOneMonth = (date: string): boolean => {
  if (!date) return true;
  const now = DateTime.now();
  const targetDate = DateTime.fromISO(date);
  const diffInMonths = now.diff(targetDate, 'months').months;
  return diffInMonths > 1;
};

/**
 * @description Find a default option for a given key in the questionnaire tenx form.
 * @param {string} key Key to search for in the options.
 * @returns {(QuestionnaireTenxOption | null)} The default option or null if not found.
 */
export const qUtilsTenxFindDefaultOption = (
  key: QuestionnaireTenxFormField
): QuestionnaireTenxOption | null => {
  return (
    QUESTIONNAIRE_TENX_DATA[key]?.options?.find(
      (opt) => opt.isDefault === true
    ) ?? null
  );
};

/**
 * @description Filter options for a given key in the questionnaire tenx form.
 * @param {QuestionnaireTenxFormField} key Key to filter options by.
 * @returns {Array<QuestionnaireTenxOption>} The filtered default options.
 */
export const qUtilsTenxFilterDefaultOption = (
  key: QuestionnaireTenxFormField
): Array<QuestionnaireTenxOption> => {
  return (
    QUESTIONNAIRE_TENX_DATA[key]?.options?.filter(
      (opt) => opt.isDefault === true
    ) ?? []
  );
};
